export const TOPIC_ELEMENT_ID_PREFIX = 'VivaTopics';
export const TOPIC_ENTITY_TYPE = 'OWAVivaTopics';
